import React, { useState } from "react";
import { isMobileDevice } from "../../../../utils/DeviceDetector";

const phoneIcon = 'https://cdn.obsess-vr.com/fendi/phone-final.png';
import './CallToOrder.css';
import { CallToOrderClicked } from "../../../../utils/Analytics";
import { getStoreId, singaporeStoreId } from "../../../../utils/StoreConfigManager";

const CallToOrder = ({ className, isCentered }) => {
    const phoneNumber = singaporeStoreId === getStoreId() ? `+65 6688 7119` : `646 952 8399`;
    const [showNumber, setShowNumber] = useState(false);
    const isMobile = isMobileDevice();
    const href = isMobile ? `tel:${phoneNumber}` : 'javascript:void(0)';

    const onNumberClick = () => {
        if (!isMobile) {
            if (!showNumber) {
                CallToOrderClicked();
            }
            setShowNumber(!showNumber);
        } else {
            CallToOrderClicked();
        }
    }
    return <>
        <a className={`call-to-order-btn-wrapper ${className} ${isCentered ? 'margin15-auto' : ''}`} style={{ margin: '8px auto' }} onClick={onNumberClick} href={href}>
            <img src={phoneIcon}/>
            <span className="call-to-order-btn" >{!showNumber ? 'Contact Us' : phoneNumber} </span>
        </a>
    </>
}

export default CallToOrder;
